var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 0.625H17.375C17.6071 0.625 17.8296 0.717187 17.9937 0.881282C18.1578 1.04538 18.25 1.26794 18.25 1.5V15.5C18.25 15.7321 18.1578 15.9546 17.9937 16.1187C17.8296 16.2828 17.6071 16.375 17.375 16.375H1.625C1.39294 16.375 1.17038 16.2828 1.00628 16.1187C0.842187 15.9546 0.75 15.7321 0.75 15.5V1.5C0.75 1.26794 0.842187 1.04538 1.00628 0.881282C1.17038 0.717187 1.39294 0.625 1.625 0.625ZM6.4375 10.25V12H8.625V13.75H10.375V12H11.25C11.8302 12 12.3866 11.7695 12.7968 11.3593C13.207 10.9491 13.4375 10.3927 13.4375 9.8125C13.4375 9.23234 13.207 8.67594 12.7968 8.2657C12.3866 7.85547 11.8302 7.625 11.25 7.625H7.75C7.63397 7.625 7.52269 7.57891 7.44064 7.49686C7.35859 7.41481 7.3125 7.30353 7.3125 7.1875C7.3125 7.07147 7.35859 6.96019 7.44064 6.87814C7.52269 6.79609 7.63397 6.75 7.75 6.75H12.5625V5H10.375V3.25H8.625V5H7.75C7.16984 5 6.61344 5.23047 6.2032 5.6407C5.79297 6.05094 5.5625 6.60734 5.5625 7.1875C5.5625 7.76766 5.79297 8.32406 6.2032 8.7343C6.61344 9.14453 7.16984 9.375 7.75 9.375H11.25C11.366 9.375 11.4773 9.42109 11.5594 9.50314C11.6414 9.58519 11.6875 9.69647 11.6875 9.8125C11.6875 9.92853 11.6414 10.0398 11.5594 10.1219C11.4773 10.2039 11.366 10.25 11.25 10.25H6.4375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipping);
export default __webpack_public_path__ + "static/media/tipping.7cbb7674.svg";
export { ForwardRef as ReactComponent };